import { render, staticRenderFns } from "./ProjectShow.vue?vue&type=template&id=8b97b1c6&scoped=true&"
import script from "./ProjectShow.vue?vue&type=script&lang=js&"
export * from "./ProjectShow.vue?vue&type=script&lang=js&"
import style0 from "./ProjectShow.vue?vue&type=style&index=0&id=8b97b1c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b97b1c6",
  null
  
)

export default component.exports